export default ({...props}) => {
  const {size, space} = props.theme
  return `
    & > .MuiBox-root.dense-box {
        margin: ${space(1.25)}px; 0 ${space(3.75)}px 0;
    }

    & .eJJiMd[ap_atom_name='textfieldAtom'] > .MuiInputBase-formControl {
        width: ${size(12.5)}%;
    }

    & > form .input-wrapper-box.MuiBox-root {
        margin-bottom: ${space(3.75)}px;
    }

    & form > .login-submit-btn-wrapper-box {
        width: ${size(12.5)}%;
        height: ${size(4.25)}px;

        & button {
            height: ${size(12.5)}%;
        }

        &.cursor-not-allowed {
            cursor: not-allowed;
        }
        & > button.btn-disabled {
            opacity: 0.5;
            pointer-events: none;
        }
    }

    & > form .error-wrapper-box.MuiBox-root {
        min-height: ${space(3.75)}px;
        margin-bottom: ${space(3.125)}px;

        & > p.MuiTypography-root {
            text-align: center;
        }
    }

    @media screen and (max-width: 321px) {
        & [ahd_type='sData'] {
            font-size: 0.675rem;
        }
    }


    @media only screen 
    and (min-device-width: 375px) 
    and (max-device-width: 736px) 
    and (-webkit-min-device-pixel-ratio: 2) 
    and (orientation: portrait) {
        & > form .error-wrapper-box.MuiBox-root {
            min-height: 0px;
        }
    }
`
}
